function productcarousel(){
  var productslider=[];
  document.querySelectorAll('.product-carousel').forEach(function(Element,index){
    let productid = Element.dataset.id;
    let outer_carousel = Element.closest('.carousel-rowouter');
    let nextbutton = outer_carousel.querySelectorAll('.swiper-button-next')[0];
    let prevbutton = outer_carousel.querySelectorAll('.swiper-button-prev')[0];
    let paginate = outer_carousel.querySelectorAll('.swiper-pagination')[0];
    let swiperObject = {
      loop: eval(Element.dataset.loop),
      slidesPerView: "auto",
      slidesPerGroup: 2,
      noSwiping: true,                 // usually true by default, but be explicit
      noSwipingClass: 'swiper-no-swiping',
      navigation: {
        nextEl: nextbutton,
        prevEl: prevbutton,
      },
      pagination: {
        el: paginate,
        clickable: true
      },
      breakpoints: {
       768: {
          slidesPerGroup: 1,
        },
        992: {
          pagination: false,
          slidesPerGroup: 1,
        },
      }
    };
    productslider[productid]=new Swiper(Element,swiperObject);
  });
}
productcarousel();